import { render, staticRenderFns } from "./capital-risk-disclosure.vue?vue&type=template&id=319d4f30&scoped=true"
import script from "./capital-risk-disclosure.vue?vue&type=script&lang=js"
export * from "./capital-risk-disclosure.vue?vue&type=script&lang=js"
import style0 from "./capital-risk-disclosure.vue?vue&type=style&index=0&id=319d4f30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d4f30",
  null
  
)

export default component.exports